export enum ResponseCode {
  OK = 200,
  INTERNAL_SERVER_ERROR = 500
}
